import { PutEcshopAccountsApi } from "@/features/accounts/ecshop/services/put-accounts-api";
import { PutEcshopAccountsRequestModel } from "@/features/accounts/ecshop/services/put-accounts-model";

/// その他連携サービス口座更新処理
export class PutEcshopAccountsService {
  private putEcshopAccountsApi = new PutEcshopAccountsApi();

  /**
   * その他連携サービス口座更新API実行
   */
  public async putEcshopAccounts(param: PutEcshopAccountsRequestModel) {
    return await this.putEcshopAccountsApi.putEcshopAccounts(param);
  }
}
